const SIZE = /(\d{1,3}\s*[xX×]\s*\d{1,3}(?:\s*[xX×]\s*\d{1,3})?)/;

/** Size is not its own column yet. Pull a 12x20-style token out of the model text. */
export function splitModelAndSize(hint: string | null | undefined): { model: string; size: string } {
  const raw = (hint ?? "").trim();
  if (!raw) return { model: "", size: "" };
  const match = raw.match(SIZE);
  if (!match || match.index == null) return { model: raw, size: "" };
  const size = match[1].replace(/\s+/g, "").replace(/×/gi, "x").toLowerCase();
  const model = `${raw.slice(0, match.index)} ${raw.slice(match.index + match[1].length)}`
    .replace(/\s+/g, " ")
    .replace(/^[-·,]+|[-·,]+$/g, "")
    .trim();
  return { model, size };
}
